export default __webpack_public_path__ + "static/website-meta-21289bce37d8a1ed77f6674ba8cbed20.png";